export enum UserRoles {
  AccessAU = "Access.AU",
  AccessNZ = "Access.NZ",

  ProductDefaultAccess = "Product.DefaultAccess",
  ProductStaffPrice = "Product.StaffPrice",
  ProductGoCost = "Product.GoCost",
  ProductGoSell = "Product.GoSell",
  ProductAverageCostEx = "Product.AverageCostEx",
  ProductUnitCostEx = "Product.UnitCostEx",
  ProductOnlineDetails = "Product.OnlineDetails",
  ProductPurchaseOrders = "Product.PurchaseOrders",
  ProductManage = "Product.Manage",
  ProductManageReadWrite = "Product.Manage.ReadWrite",
  ProductBrandImages = "Product.BrandImages",
  ProductBrandImagesReadWrite = "Product.BrandImages.ReadWrite",
  ProductSEO = "Product.SEO",
  ProductMessaging = "Product.Messaging",
  ProductSync = "Product.IMSSync",
  ProductProdToUATSync = "Product.ProdToUATSync",
  ProductHistory = "Product.History",

  PricingWasPrices = "Pricing.WasPrices",
  PricingWasPricesReadWrite = "Pricing.WasPrices.ReadWrite",
  PricingActivePromotions = "Pricing.ActivePromotions",
  PricingFuturePromotions = "Pricing.FuturePromotions",
  PricingExpiredPromotions = "Pricing.ExpiredPromotions",
  PricingHistoricPricing = "Pricing.HistoricPricing",
  PricingStaffExceptions = "Pricing.StaffExceptions",

  InventoryDetails = "Inventory.Details",
  InventoryTotals = "Inventory.Totals",
}
